/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Anna_Quote_P1Inputs */

const en_marketing_app_anna_quote_p1 = /** @type {(inputs: Marketing_App_Anna_Quote_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm really picky about AI voices, but `)
};

const es_marketing_app_anna_quote_p1 = /** @type {(inputs: Marketing_App_Anna_Quote_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soy muy exigente con las voces de IA, pero `)
};

/**
* | output |
* | --- |
* | "I'm really picky about AI voices, but" |
*
* @param {Marketing_App_Anna_Quote_P1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_anna_quote_p1 = /** @type {((inputs?: Marketing_App_Anna_Quote_P1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Anna_Quote_P1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_anna_quote_p1(inputs)
	return en_marketing_app_anna_quote_p1(inputs)
});